import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { clearSession } from "../store/reducers/sessionSlice";
import { getAdminUrl, getLoginApplicationUrl } from "../utils/config-utils";
import {
  clearPersistedPinLock,
  getErrorCode,
  pinErrorMessage,
} from "../utils/pin-utils";

/**
 * MED-1622: turns a failed PIN call into the message the lock screen shows.
 * The 5th wrong PIN revokes every token of the user (401
 * PIN_ATTEMPTS_EXCEEDED): the session is cleared and the user sent to login.
 */
export const usePinErrorHandler = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return useCallback(
    (error: unknown): string => {
      if (getErrorCode(error) === "PIN_ATTEMPTS_EXCEEDED") {
        clearPersistedPinLock();
        dispatch(clearSession());
        window.location.href = getLoginApplicationUrl(getAdminUrl());
      }
      return pinErrorMessage(t, error);
    },
    [t, dispatch]
  );
};
